module.exports = __webpack_public_path__ + "img/pg4-article2.7bc0acce.png";